module.exports = __webpack_public_path__ + "img/ic_dropdown_open_grey.e6d248a8.svg";